export default {
    authAuthority: Settings.authAuthority,
    translationsApi: Settings.translationsApi,
    translationServerDev: Settings.translationServerDev,
    kritaApi: Settings.kritaApi,
    // kritaApi: 'https://krita.local/api/',
    GetUrl: function(url)
    {
        url = url.replace(/\/$/, '');
        return url + `/`;
    }
};
